module.exports = __webpack_public_path__ + "static/media/play.c60b462f.svg";